<template>
<router-view></router-view>
</template>

<script>

export default {
    name: "OrdersPage",
}
</script>

<style scoped>

</style>